


import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {Timeline, TimelineLite} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {HarlequinReelSymbol} from "../../symbols/HarlequinReelSymbol";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";

export class HarlequinCollectManager implements GameRoundPresentation {

    private _hasWinFreespin:boolean = false;
    private _hasWinBaseGame:boolean = false;
    private _reset:boolean = false;
    private _fsStartReset:boolean = false;
    private _wildDrop:boolean [] = [];

    private _reels:string [][] = [];

    private _extraScatterThisFSSpin:number [];
    private _scattersCollectedAfter:number;
    private _scattersCollectedBefore:number;
    private _scattersCollected:number;
    private _scatterPositions:number [];

    private _tl:Timeline;
    private _endDelay:number = 0.35;
    private _freespinPlayed:number = 0;
    private _isFreespin:boolean = false;
    private _isFreespinNext:boolean = false;
    private _freespinTriggeredThisSpin:boolean = false;
    private _mode:string;
    private _nextMode:string;
    private _isRestore:boolean;
    private _wildOverlays:boolean [] = [];
    private _aborted:boolean = false;
    private _setupDone:boolean = false;
    private _scatterCollected:number;

   private _reelId:number;


    // TODO:
    /*
            The collecting for FS are handled by HarlequinAddFreespin

            This class will handle base game collecting
     */
    constructor(reset:boolean = false, fsStartReset:boolean = false) {
        this._reset = reset;
        this._fsStartReset = fsStartReset;
    }

    prepare(data:HarlequinParsedGameData):void {
        /*if(this._tl) {
            this._tl.pause();
            this._tl.kill();
        }*/
        this._aborted = false;
        this._setupDone = false;
        //HarlequinScatterCollector.HAS_UPDATED_THIS_ROUND = false;
        this._hasWinFreespin = (this._scattersCollectedAfter > 0) && this._isFreespin;//(data.scattersCollected > 0);
        this._hasWinBaseGame = (data.scattersCollected > 0);
        this._mode = data.mode;
        this._nextMode = data.nextMode;

        this._isFreespin = data.mode === GameMode.FREESPIN || data.mode === "WILD_RESPIN_FS";
        this._isFreespinNext = ((data.mode === GameMode.NORMAL || data.mode === "WILD_RESPIN") && data.nextMode === GameMode.FREESPIN);
        this._scattersCollected = data.scattersCollected;
        this._scattersCollectedAfter = data.scattersCollectedFSAfter;
        this._scatterPositions = (data.scatterPositions)? data.scatterPositions : [-1,-1,-1,-1,-1];
        this._extraScatterThisFSSpin = (data.extraScatterThisFSSpin)? data.extraScatterThisFSSpin : [-1,-1,-1,-1,-1];
        this._reels = data.reels;
        this._freespinTriggeredThisSpin = data.freespinTriggeredThisSpin;
        this._isRestore = (<any> data).isRestoreState;
        this._wildOverlays = data.wildOverlayReels || [];
        //this._scattersCollected = data.scatterCollected;


        this._freespinPlayed = data.freespinPlayed;
    }

    getAnimation():Timeline {
        const tl:Timeline = new TimelineLite();

        if(this._reset) {
            //debugger;
            HarlequinGameModuleConfig.harlequinScatterCollectorView.resetIndicators();
            //debugger;
            HarlequinGameModuleConfig.harlequinSignView.resetHeadSpine();
            tl.add(() => {
                HarlequinGameModuleConfig.harlequinSignView.resetHeadSpine();
            });
        }

        // TODO: add specific restore state handler for sign and collect indicators

        if(!this._reset && this._hasWinBaseGame) {
            tl.add(this.setupCollectAnimations());
        }


        this._tl = tl;
        return this._tl;
    }

    protected setupCollectAnimations():Timeline {
        const tl:Timeline = new TimelineLite();

        if (this._isRestore && this._mode === "WILD_RESPIN") {

            //HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGameToRespin");
        }

        if(this._hasWinBaseGame) {
            let cntr:number = 0;


            if(this._mode === "NORMAL" && this._nextMode === "WILD_RESPIN") {
                let numberLeft:number = -1;
                this._wildOverlays.forEach((evalVal:boolean, index:number) => {
                    if(evalVal) {
                        numberLeft = index;
                    }
                });

                //HarlequinGameModuleConfig.harlequinSignView.playSignSpine("baseGameToRespin", undefined, undefined, undefined, numberLeft - 1);
                HarlequinGameModuleConfig.harlequinSignView.enterMode(this._mode, this._nextMode);
            }


            if(!this._setupDone) {
                this._setupDone = true;
                let collected: number = this._scattersCollected;
                let reelId = 0;

                while(this._scatterPositions.length > 0) {
                    const position = this._scatterPositions.shift();

                    if ((position || position === 0) && position > -1 && this._nextMode !== "NORMAL") {

                        if (collected > 0) {
                            collected = collected--;
                        }

                        /*
                        if (collected > 0) {
                            collected = collected++;
                        } else {
                            collected = 0;
                        }
                         */

                        const symbol: StateReelSymbol = Reels.getSymbol(reelId, position)!;
                        tl.add(() => {
                            if (symbol) {
                                if(!this._aborted) {
                                    (<HarlequinReelSymbol>symbol).playScatterAttention();
                                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.SCATTER_LIT);
                                }
                            }
                        }, "+=0.25");
                        tl.add([
                            //() => console.log("SCATTER POSITION: " + position),
                            () => {
                                // TODO, need new calculation for which head to be lit
                                //debugger;
                                //HarlequinGameModuleConfig.harlequinSignView.playHeadSpine(undefined, cntr++, true);
                                if (collected + 1 > 0) {
                                    //debugger;
                                    HarlequinGameModuleConfig.harlequinSignView.litNextHead();//this._scattersCollected--;
                                    // HarlequinGameModuleConfig.harlequinScatterCollectorView.updateIndicator(collected, true, true);
                                }
                            }
                        ], (!this._wildDrop[4]) ? "+=0.35" : "+=0");
                        tl.add(() => {
                        }, "+=" + this._endDelay);

                        if (reelId === 1 && this._freespinTriggeredThisSpin) {
                            tl.add(() => {
                                //HarlequinGameModuleConfig.harlequinSignView.playSignSpine("respinToBonusGameWon");
                                HarlequinGameModuleConfig.harlequinSignView.playRightBar("New3HeadsBonusGameTextDefault")
                            });
                        }
                    }

                    reelId++;
                }
            }
        }


        if(this._scattersCollected === 3 && this._freespinTriggeredThisSpin) {
            tl.add(() => {
                //HarlequinGameModuleConfig.harlequinSignView.playHeadSpine("HeadActive3", 0, true);
            }, "+=0.5");
        }

        this._tl = tl;



        return tl;
    }

    abort(isActive: boolean, data: HarlequinParsedGameData): Timeline | null {
        this._aborted = true;
        if(isActive && this._tl) {
            GameRoundManager.detachAndPlayTimeline(this._tl);
            if(this._isFreespinNext) {
                const tl: TimelineLite = new TimelineLite();
                tl.add(() => {}, 3.0);
                return tl;
            }
        }
        return null;
    }

}